/*global
  google
*/

import Locator from "./locator";
import Glide from "@glidejs/glide";
import {Fancybox} from "@fancyapps/ui";
import Isotope from "isotope-layout";
import Gumshoe from 'gumshoejs/src/js/gumshoe/gumshoe';
import SmoothScroll from 'smooth-scroll/src/js/smooth-scroll/smooth-scroll';
import { Loader } from "@googlemaps/js-api-loader";

// maps API
const loader = new Loader({
    apiKey: "AIzaSyAiefms-Al1hZz3rYjXS8igeJnLyvdDZY0",
    version: "weekly",
    libraries: ["places"],
});
const stylesArray = [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}];


export default class RL {
    constructor() {
        this.init();
    }

    init () {
        // Scrollspy
        document.querySelector('.internal-nav a') && new Gumshoe('.internal-nav a', {
            offset: 47,
        });
        document.querySelector('.internal-nav a') && new SmoothScroll('.internal-nav a', {
            offset: 47,
        });

        // Locators
        const locators = document.querySelectorAll('.locator');
        locators.forEach(locator => {

            if (locator.querySelector('.ads-location')) {
                const ads = Array.from(document.querySelectorAll('.ads-location'));
                const data = ads
                    // First reduce to remove duplicates
                    .reduce(function (prev, curr) {
                        return prev.some(val => (val.dataset.lat === curr.dataset.lat && val.dataset.lng === curr.dataset.lng))
                            ? prev
                            : prev.concat(curr);
                    }, [])
                    // map to make a new array
                    .map(ad => {
                        const lat = parseFloat(ad.dataset.lat || 0);
                        const lng = parseFloat(ad.dataset.lng || 0);
                        const filters = Array.from(ad.querySelectorAll('[data-filter]')).map(el => el.dataset.filter.split(',,'));
                        return {
                            'el': ad,
                            'html': ad.outerHTML,
                            'lat': lat,
                            'lng': lng,
                            'premium': (typeof ad.dataset.premium !== 'undefined'),
                            'filters': filters,
                        };
                    });
                new Locator(data, locator);
            }
        });

        // glide
        Array.from(document.querySelectorAll('.vmch-slider')).forEach(slider => {
            const glide = new Glide(slider, {
                type: 'carousel',
                perView: 1.5,
                breakpoints: {
                    767: {
                        perView: 1,
                    },
                },
            }).mount();
            glide.on('move.after', () => {
                const counterEl = slider.querySelector('.glide__counter__int');
                if (counterEl) {
                    counterEl.innerText = glide._i + 1;
                }
            });
        })

        // New slider
        Array.from(document.querySelectorAll('.vmch-new-slider')).forEach(slider => {
            const glide = new Glide(slider, {
                type: 'carousel',
                perView: 1,
                breakpoints: {
                    767: {
                        perView: 1,
                    },
                },
            }).mount();
            glide.on('move.after', () => {
                const counterEl = slider.querySelector('.glide__counter__int');
                if (counterEl) {
                    counterEl.innerText = glide._i + 1;
                }
            });
        })

        // testimonials
        Array.from(document.querySelectorAll('.vmch-testimonials')).forEach(slider => {
            const glide = new Glide(slider, {
                type: 'carousel',
                perView: 1,
                gap: 0,
            }).mount();
            glide.on('move.after', () => {
                const counterEl = slider.querySelector('.glide__counter__int');
                if (counterEl) {
                    counterEl.innerText = glide._i + 1;
                }
                const imagesEl = Array.from(slider.querySelectorAll('.vmch-testimonials_images_item'));
                if (imagesEl.length > glide._i) {
                    imagesEl.forEach(el => el.classList.remove('active'))
                    imagesEl[glide._i].classList.add('active');
                }
            });
        })

        // vacancy gallery
        Array.from(document.querySelectorAll('.single-for-sale .glide')).forEach(slider => {
            const glide = new Glide(slider, {
                type: 'carousel',
                perView: 1,
            }).mount();
            glide.on('move.after', () => {
                const counterEl = slider.querySelector('.glide__counter__int');
                if (counterEl) {
                    counterEl.innerText = glide._i + 1;
                }
            });
            // Workaround to fix IPhone issue
            // Source:  https://github.com/glidejs/glide/issues/417
            const glideArrowLeft = document.querySelector('.glide__arrow--left')
            const glideArrowRight = document.querySelector('.glide__arrow--right')

            glideArrowLeft.addEventListener('click', function() {
                glide.go('<');
            })

            glideArrowRight.addEventListener('click', function() {
                glide.go('>');
            })
        })

        // map
        Array.from(document.querySelectorAll('.map-surroundings')).forEach(mapEl => {
            const center = {
                lat: mapEl.dataset['lat'] ? Number(mapEl.dataset['lat']) : -37.81626642355492,
                lng:  mapEl.dataset['lng'] ? Number(mapEl.dataset['lng']) : 144.9640545848708,
            };
            loader.load().then(() => {
                const map = new google.maps.Map(mapEl, {
                    center,
                    zoom: 15,
                    styles: stylesArray,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                });
                new google.maps.Marker({
                    position: center,
                    map,
                });
            });
        })

        // Fancybox
        Fancybox.bind("[data-fancybox]");

        // Isotope
        const urlParams = new URLSearchParams(location.search);
        let activeFilter = urlParams.get('location') || '*';
        const iso = new Isotope( '.grid', {
            filter: function() {
                return activeFilter === '*' || activeFilter === 'all' || (this.dataset.village && this.dataset.village === activeFilter || this.dataset.premium && activeFilter === "premium" || !this.dataset.premium && activeFilter === "village" );
            },
        });

        // filter items on button click
        const locationsFilters = Array.from(document.querySelectorAll('.post-type-archive-for-sale__filters .list div'));
        const premiumFilters = Array.from(document.querySelectorAll('.post-type-archive-for-sale__legend div'));
        [...locationsFilters, ...premiumFilters]
            .forEach(el => {
                el.addEventListener('click', () => {
                    locationsFilters.forEach(el => el.classList.remove('active'));
                    premiumFilters.forEach(el => el.classList.remove('active'));
                    premiumFilters.forEach(el => el.classList.remove('disabled'));
                    if (!el.dataset.filter) {
                        activeFilter = '';
                    } else if (el.dataset.filter === activeFilter) {
                        activeFilter = '*';
                    } else {
                        activeFilter = el.dataset.filter;
                        if (premiumFilters.includes(el)) {
                            premiumFilters.forEach(el => el.classList.add('disabled'));
                            el.classList.remove('disabled');
                        }
                        el.classList.add('active');
                    }
                    iso.arrange();
                })
            })
        // highlight active filter
        const activeFilterEl = document.querySelector('div[data-filter="' + activeFilter + '"]');
        activeFilterEl && activeFilterEl.classList.add('active');

        // Vacancies archive Filters
        const vacanciesArchiveFilters = document.querySelector('.post-type-archive-for-sale__filters');
        if (vacanciesArchiveFilters) {
            const filtersBtn = vacanciesArchiveFilters.querySelector('.post-type-archive-for-sale__filters button');
            const filtersLst = vacanciesArchiveFilters.querySelector('.post-type-archive-for-sale__filters .list');
            if (vacanciesArchiveFilters && filtersBtn && filtersLst) {
                filtersBtn.addEventListener('click', () => {
                    const filtersList = filtersBtn.nextElementSibling;
                    if (!filtersList) return;
                    vacanciesArchiveFilters.classList.toggle('shown');
                })
                if (activeFilter !== '*') vacanciesArchiveFilters.classList.add('shown');
            }
        }

        // TODO modals
        // const foo = document.querySelectorAll('.post-type-archive-for-sale__legend__dot');
        // foo.forEach(el => {
        //     el.addEventListener('click', () => {
        //         //
        //         const bar = document.querySelector('.post-type-archive-for-sale__modal');
        //         bar && bar.classList.add('show');
        //     })
        // })
    }
}



// WEBPACK FOOTER //
// ./scripts/components/retirement-living.js